import React from "react";
import styled, { withTheme } from "styled-components";

export const Wrapper = styled.div`
  .card-separator {
    background: ${(props) => props.theme?.purpleGradient};
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#a7208c",endColorstr="#59095e",GradientType=1);
  }
  .card-header-separator {
    width: 40px;
    height: 3px;
    margin-top: 0.3rem;
  }

  .card-header-separator-lg {
    width: 62px;
    height: 5px;
    margin-top: 0.5rem;
  }
  .card-header-separator-green {
    width: 40px;
    height: 3px;
    margin-top: 0.5rem;
    background: ${(props) => props.theme?.greenGradient};
  }
`;

const CardSeparator = (props) => {
  const { style } = props;
  const availableStyles = ["-lg", "-green"];
  const aditionalStyle = availableStyles.includes(style) ? style : "";
  return (
    <Wrapper>
      <div
        data-testid="card-separator"
        className={`card-separator card-header-separator${aditionalStyle}`}
      ></div>
    </Wrapper>
  );
};

CardSeparator.defaultProps = {
  style: "",
};

export default withTheme(CardSeparator);
